export default "<div  style=\"width: 100px;\">\r\n    <canvas id=\"{{elemId}}\" >{{ chart }}</canvas>\r\n</div>";